<template>
    <div class="content">
        <router-view></router-view>
        <div class="content-body">
            <div class="widgets">
              <div class="widgets-wrapper">

                <InvoiceStatsResumeWidget title="Chiffre d'affaires des ventes" period="current_month" class-name=""></InvoiceStatsResumeWidget>

                <OrderStatsWidget title="Rapport des ventes" period="current_month" class-name="fullx" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')"></OrderStatsWidget>
                <OrderStatsWidget title="Rapport des ventes" period="since_3_months" v-if="$aclInterfaceValidator('weeboxshop.order.statsca')"></OrderStatsWidget>
                <OrderBestsellersWidget title="Meilleures ventes" period="since_3_months"></OrderBestsellersWidget>

                <GoogleAnalyticsWidget title="Visites du site" period="current_month"></GoogleAnalyticsWidget>
                <GoogleAnalyticsSourcesWidget title="Source des visites" period="current_month"></GoogleAnalyticsSourcesWidget>

                <StatsAquisitionCohortWidget
                    :title="'Lifetime Value / Clients'"
                    type="all"
                    period="current_year"
                    class-name="full"
                    v-if="$aclInterfaceValidator('weeboxcore.invoice.statsca')"></StatsAquisitionCohortWidget>

                <OrderCustomerWidget title="Clients" period="current_month"></OrderCustomerWidget>

              </div>
            </div>
        </div>
    </div>
</template>
<script>

    import OrderWidget from './order/OrderWidget.vue'
    import AllWidget from './order/AllWidget.vue'
    import InvoiceStatsResumeWidget from '../invoicing/invoice/StatsResumeWidget.vue'
    import OrderStatsWidget from './order/OrderStatsWidget.vue'
    import OrderBestsellersWidget from './order/OrderBestsellersWidget.vue'
    import OrderCustomerWidget from '../shop/order/OrderCustomerWidget.vue'
    import StatsAquisitionCohortWidget from '../invoicing/invoice/StatsAquisitionCohortWidget.vue'
    import GoogleAnalyticsWidget from '../google/GoogleAnalyticsWidget.vue'
    import GoogleAnalyticsSourcesWidget from '../google/GoogleAnalyticsSourcesWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){
        },
        components: {
            'OrderWidget' : OrderWidget,
            'AllWidget' : AllWidget,
            'OrderStatsWidget' : OrderStatsWidget,
            'StatsAquisitionCohortWidget' : StatsAquisitionCohortWidget,
            'InvoiceStatsResumeWidget' : InvoiceStatsResumeWidget,
            'OrderBestsellersWidget' : OrderBestsellersWidget,
            'OrderCustomerWidget': OrderCustomerWidget,
            'GoogleAnalyticsWidget': GoogleAnalyticsWidget,
            'GoogleAnalyticsSourcesWidget': GoogleAnalyticsSourcesWidget
        },
        methods: {
            edit: function(id){
                this.$router.push('/person/'+id);
            },
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/shop/Dashboard.vue